import React, { useState } from 'react';
import { Flex } from 'rebass';
import { SearchInput } from '../../components/Form';
import Button from '../../components/Button/Button';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { FilterBarProps } from '../../components/FilterBar/FilterBar';
import { rebassProps } from '../../theme/theme';
import { getStringSearchOr } from '../../helpers/search';

const stringSearchFields = [
  {
    field: 'profile.name',
    label: 'First Name',
  },
  {
    field: 'email',
    label: 'Email',
  },
];

type FilterBarUserProps = Omit<
  FilterBarProps<Record<string, any>>,
  'selectedId'
>;

const FilterBarUser: React.FC<FilterBarUserProps> = (props) => {
  const { filters = {}, setFilters } = props;
  const [stringSearch, setStringSearch] = useState<string>('');

  return (
    <Flex variant="filterBar.container" {...(props as rebassProps)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder="name, email"
          autoFocus={isBrowser}
          width={300}
          value={stringSearch}
          onChange={(event) => {
            setStringSearch(event.target.value);
            if (setFilters) {
              setFilters({
                ...filters,
                or: getStringSearchOr(stringSearchFields, event.target.value),
              });
            }
          }}
        />
      </Flex>

      <Flex variant="filterBar.right">
        <Button
          variant="outline"
          icon="undo"
          onClick={() => {
            if (setFilters) {
              setFilters({
                type: 1,
              });
            }
          }}
          title="Reset Form"
        />
      </Flex>
    </Flex>
  );
};

FilterBarUser.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarUser;
